module.exports = __webpack_public_path__ + "img/edge-out-2.d6dda44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/edge-out-2.png
// module id = 617
// module chunks = 1